import type {
  ReactElement,
  ReactNode,
} from 'react';
import styled from 'styled-components';

import { Button } from '../Button';
import { ButtonToolbar } from '../ButtonToolbar';
import { Modal } from '../Modal';

import { showModal } from '../showModal';

export const StyledContent = styled.div(({
  theme: {
    colors,
  },
}) => ({
  color: colors.NEUTRAL_DEFAULT,
}));

export type ShowAlertParams = {
  title?: string;
  content?: ReactNode;
  buttonText?: string;
};

export type AlertProps = ShowAlertParams & {
  resolveModal: () => void;
};

export function Alert({
  buttonText = 'Ок',
  content = undefined,
  resolveModal,
  title = undefined,
}: AlertProps): ReactElement {
  return (
    <Modal
      show
      onHide={resolveModal}
    >
      <>
        {
          title && (
            <Modal.Title>
              {title}
            </Modal.Title>
          )
        }

        <Modal.Body>
          {
            content && (
              <StyledContent>
                {content}
              </StyledContent>
            )
          }
        </Modal.Body>

        <Modal.Footer>
          <ButtonToolbar align="right">
            <Button
              componentProps={{
                type: 'button',
              }}
              onClick={resolveModal}
              color="primary"
            >
              {buttonText}
            </Button>
          </ButtonToolbar>
        </Modal.Footer>
      </>
    </Modal>
  );
}

export const showAlert = ({
  title,
  content,
  buttonText,
}: ShowAlertParams): Promise<void> => showModal<void>(
  ({ resolveModal }) => (
    <Alert
      title={title}
      content={content}
      buttonText={buttonText}
      resolveModal={resolveModal as () => void}
    />
  ),
);
